import { flatten } from 'lodash';
import { ColumnsType } from 'antd/lib/table';
import { getColumnFilteredValue, getColumnSortOrder } from '../../components/table/columnFormatHelpers';
import { DISPATCH_TYPE_TEXT_MAP, DISPATCH_TYPE_FILTER_VALUES } from '../../pages/sites/siteInterface';
import { compareWithLocale } from '../compareWithLocale';
import { ISite } from './interface';

export const getDispatchTypeFilterValue = (state: any) => {
    let { filteredValue } = getColumnFilteredValue('dispatch_type', state?.filter || {});
    if (Array.isArray(filteredValue)) {
        filteredValue = flatten(filteredValue);
    }
    return filteredValue;
};

export function buildSiteDispatchTypeTableFilter(state: any, sidebarEnabled: boolean) {
    const column: ColumnsType<ISite>[number] = {
        key: 'dispatch_type',
        title: 'Dispatch Type',
        dataIndex: 'dispatch_type',
        width: 120,
        render: (text, record) => DISPATCH_TYPE_TEXT_MAP[text],
        sorter: (a: ISite, b: ISite) => compareWithLocale(a.dispatch_type, b.dispatch_type),
        ...getColumnSortOrder('dispatch_type', state.sorter),
    };

    return sidebarEnabled
        ? [column]
        : [{ ...column, filterMultiple: false, filters: DISPATCH_TYPE_FILTER_VALUES, filteredValue: getDispatchTypeFilterValue(state) }];
}
